import type {
  Granularity,
  OfferBreakdownResponse,
  SyncResponse,
  TargetsResponse,
} from '../types/budget-actual.js';
import { request } from './api.js';

/**
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business 予実管理 API クライアント。目標データ取得（/budget-actual/targets、粒度指定対応）、オファーの内訳（/budget-actual/offer-breakdown）とスプシ同期（/budget-actual/sync）を提供する。
 * @graph-connects /budget-actual/targets [calls] 目標データ取得
 * @graph-connects /budget-actual/offer-breakdown [calls] オファーの内訳取得
 * @graph-connects /budget-actual/sync [calls] スプシ同期
 */
export const budgetActualApi = {
  getTargets: (params?: {
    from?: string;
    to?: string;
    granularity?: Granularity;
  }): Promise<TargetsResponse> => {
    const qs = new URLSearchParams();
    if (params?.from) qs.set('from', params.from);
    if (params?.to) qs.set('to', params.to);
    if (params?.granularity) qs.set('granularity', params.granularity);
    const query = qs.toString();
    return request<TargetsResponse>(
      query ? `/budget-actual/targets?${query}` : '/budget-actual/targets',
    );
  },
  getOfferBreakdown: (params?: { from?: string; to?: string }): Promise<OfferBreakdownResponse> => {
    const qs = new URLSearchParams();
    if (params?.from) qs.set('from', params.from);
    if (params?.to) qs.set('to', params.to);
    const query = qs.toString();
    return request<OfferBreakdownResponse>(
      query ? `/budget-actual/offer-breakdown?${query}` : '/budget-actual/offer-breakdown',
    );
  },
  sync: (): Promise<SyncResponse> =>
    request<SyncResponse>('/budget-actual/sync', { method: 'POST' }),
};
